module.exports = __webpack_public_path__ + "img/icon_1.bdbd7397.svg";